define('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyView',['require','view/controller/booking/datetime/TimeDefaultView','view/controller/booking/datetime/grid-weekly/TimeGridWeeklyDayView','view/controller/booking/datetime/grid-weekly/TimeGridWeeklyEmptyView','collection/TimeGridCollection','Config'],function (require) {

    var Parent = require('view/controller/booking/datetime/TimeDefaultView');
    var TimeGridWeeklyDayView = require('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyDayView');
    var TimeGridWeeklyEmptyView = require('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyEmptyView');
    var TimeGridCollection = require('collection/TimeGridCollection');
    var Config = require('Config');

    /**
     * Grid weekly timeline view (container)
     *
     * @class TimeGridWeeklyView
     */
    return Parent.extend({
        
        _activeTimeOfDay: null,
        _selectedDaysOfWeek: [],

        template: '#time_grid_weekly_view',
        childViewContainer: '#sb_time_grid_weekly_container',
        childView: TimeGridWeeklyDayView,
        
        emptyView: TimeGridWeeklyEmptyView,
        emptyViewOptions: function () {
            return {
                collectionError: this._collectionError,
                isLoaded: this.isTimeCollectionLoaded()
            };
        },
        
        ui: {
            'morning': '#sb_morning_part',
            'afternoon': '#sb_afternoon_part',
            'evening': '#sb_evening_part',
            'provider': '#sb_grid_provider_id',
            'service': '#sb_grid_service_id',
            'daysOfWeek': '.sb-day-of-week'
        },
        
        events: {
            'click @ui.morning': '_onClickMorning',
            'click @ui.afternoon': '_onClickAfternoon',
            'click @ui.evening': '_onClickEvening',
            'change @ui.provider': '_onChangeProviderFilter',
            'change @ui.service': '_onChangeServiceFilter',
            'click @ui.daysOfWeek': '_onClickDayOfWeek',
        },
        
        childViewOptions: function (model, index) {
            return _.extend({
                activeTimeOfDay: this._activeTimeOfDay,
                serviceCollection: this._serviceCollection,
                providerCollection: this._providerCollection,
                waitingListHelperModel: this.getOption('waitingListHelperModel')
            }, Parent.prototype.childViewOptions.apply(this, arguments));
        },
        
        filter: function (child, index, collection) {
            return this._filterByDaysOfWeek(child) && this._filterByTime(child); 
        },
        
        _filterByDaysOfWeek: function (dayModel) {    
            if (_.isEmpty(this._selectedDaysOfWeek)) {
                return true;
            } else {
                var date = Date.parseMysqlDate(dayModel.get('date'));
                return _.contains(this._selectedDaysOfWeek, date.getDay());
            }
        },
        
        _filterByTime: function (dayModel) {
            // if (Config.getInstance().getPluginStatus('waiting_list')) {
            //     return true;
            // }
            var timeDiff = this.getOption('clientTimeZone').get('time_diff');
            var activeTimeOfDay = this._activeTimeOfDay;
            
            return TimeGridCollection.filterByTime(dayModel.get('collection'), timeDiff, activeTimeOfDay);
        },
        
        _daysDiff: 7,
        
        initialize: function () {
            this._timeCollection = this.getOption('timeCollection');
            this.listenTo(this._timeCollection, 'error', this._onTimeCollectionError);
            this.listenTo(this._timeCollection, 'sync', this._onTimeCollectionSync);
            
            if (this._timeCollection.length) {
                this._updateCollection();
            }

            this.listenTo(this._timeCollection, 'sync', _.bind(function () {
                this._updateCollection();
                this.render();
            }, this));
            
            this._providerCollection = this.getOption('providerCollection');
            this._serviceCollection = this.getOption('serviceCollection');
            this._locationCollection = this.getOption('locationCollection');
            this._categoryCollection = this.getOption('categoryCollection');
            
            this._filterProviderId = this.getOption('filterProviderId');
            this._filterServiceId = this.getOption('filterServiceId');
            this._datesInterval = this.getOption('datesInterval');

            this.listenTo(this._providerCollection, 'sync', this.render);
            this.listenTo(this._serviceCollection, 'sync', this.render);
            this.listenTo(this._locationCollection, 'sync', this.render);
            this.listenTo(this._categoryCollection, 'sync', this.render);

            //if (Config.getInstance().getPluginStatus('waiting_list')) {
              //  this.emptyView = null;
            //}

            Parent.prototype.initialize.apply(this);
        },
        
        getTimeCollection: function () {
            return this._timeCollection;
        },

        _updateCollection: function () {
            // if (Config.getInstance().getPluginStatus('waiting_list')) {
            //     this.collection = this._timeCollection.getCollectionGroupedByClientDay(this._datesInterval.from.getMysqlDate(), this._datesInterval.to.getMysqlDate());
            // } else {
                this.collection = this._timeCollection.getCollectionGroupedByClientDay();
            //}
        },
        
        //NB copied from TimeFlexibleWeeklyView, just for from..to
        serializeData: function () {
            var _this = this;
            var result = Parent.prototype.serializeData.apply(this);

            if (this.collection) {
                var firstDay = this.collection.first();
                var lastDay = this.collection.last();

                result.available_time = [];
                if (firstDay) {
                    var collection = firstDay.get('collection');
                    collection.each(function (model) {
                        result.available_time.push(model.toJSON());
                    });

                    result.from = firstDay.get('date');
                }
                if (lastDay) {
                    result.to = lastDay.get('date');
                }
            }
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');
            
            result.is_empty = this._timeCollection.isEmptyDayCollection();
            
            // prepare providers filter (with locations)
            var selectedProviderShown = false;
            var providers = [
                {id: null, name: Locale.getNonEscape('All providers')}
            ];
            var _emptyProvidersLength = providers.length;
            if (this._locationCollection && this._locationCollection.length > 0) {
                this._locationCollection.each(function (locationModel) {
                    var subitems = _this._providerCollection.filter(function (providerModel) {
                        if (providerModel.id == 'any') return false;
                        
                        var providerLocations = providerModel.get('locations');
                        var providerServices = providerModel.get('services');
                        var validByLocation = _.isEmpty(providerLocations) || _.some(providerLocations, function(locationId) { return locationId == locationModel.id; });
                        //DEBUG cross-filtering filter values
                        var validByService = true; //!_this._filterServiceId || _.isEmpty(providerServices) || _.some(providerServices, function(serviceId) { return serviceId == _this._filterServiceId; });
                        var validByClassId = true; //!providerModel.get('class_id');  //NB not filtering out class providers
                        
                        if (validByLocation && validByService && validByClassId) {
                            if (providerModel.id == _this._filterProviderId) {
                                selectedProviderShown = true;
                            }
                            return true;
                        } else {
                            return false;
                        }
                    }).map(function (providerModel) { return providerModel.toJSON(); });
                    
                    subitems.sort(function (p1, p2) {
                        if (p1.class_id && !p2.class_id) return -1;
                        if (!p1.class_id && p2.class_id) return 1;
                        
                        var p1inLocation =  p1.position_in_location !== undefined ? ~~p1.position_in_location[locationModel.id] : Infinity;
                        var p2inLocation =  p2.position_in_location !== undefined ? ~~p2.position_in_location[locationModel.id] : Infinity;
                        return p1inLocation - p2inLocation;
                    });
                    
                    if (!_.isEmpty(subitems)) {
                        subitems.unshift({
                            id: 'location_' + locationModel.id,
                            name: Locale.getNonEscape('All providers in %location%').replace('%location%', locationModel.get('name'))
                        });
                        providers.push({
                            group: true, 
                            name: locationModel.get('name'),
                            options: subitems
                        });
                    }
                });
            } else {
                this._providerCollection.each(function (providerModel) {
                    if (providerModel.id == 'any') return false;
                    
                    var providerServices = providerModel.get('services');
                    //DEBUG cross-filtering filter values
                    var validByService = true; //!_this._filterServiceId || _.isEmpty(providerServices) || _.some(providerServices, function(serviceId) { return serviceId == _this._filterServiceId; });
                    var validByClassId = true; //!providerModel.get('class_id'); //NB not filtering out class providers
                    
                    if (validByService && validByClassId) {
                        providers.push(providerModel.toJSON());
                        
                        if (providerModel.id == this._filterProviderId) {
                            selectedProviderShown = true;
                        }
                    }
                });
                
                providers.sort(function (p1, p2) {
                    // check for 'all poviders'
                    if (~p1.id) return 1;
                    if (~p2.id) return -1;
                    
                    // place classes first
                    if (p1.class_id && !p2.class_id) return -1;
                    if (!p1.class_id && p2.class_id) return 1;
                    
                    return ~~p1.position  - ~~p2.position;
                });
            }
            //TODO why are we resetting filter just when there are no data filtered?
            // if (!selectedProviderShown) {
            //     this._filterProviderId = null;
            // }
            result.providers = providers;
            result.provider_id = this._filterProviderId;
            result.providers_disabled = providers.length == _emptyProvidersLength;

            // prepare services&classes filter (with categories)
            var selectedServiceShown = false;
            
            var classesPlugin = Config.getInstance().getOption('plugins').classes;
            var services;
            
            if (classesPlugin && ~~classesPlugin.is_active) {
                services =  [
                    {id: null, name: Locale.getNonEscape('All services and classes')},
                    {id: 'services', name: Locale.getNonEscape('Show only services')},
                    {id: 'classes', name: Locale.getNonEscape('Show only classes')},
                ];
            } else {
                services =  [
                    {id: null, name: Locale.getNonEscape('All services')},
                ];
            }
            
            var _emptyServicesLength = services.length;
            if (this._categoryCollection && this._categoryCollection.length > 0) {
                this._categoryCollection.each(function (categoryModel) {
                    var subitems = _this._serviceCollection.filter(function (serviceModel) {
                        var serviceCategories = serviceModel.get('categories');
                        var serviceProviders = _.keys(serviceModel.get('unit_map'));
                        
                        var validByCategory = _.isEmpty(serviceCategories) || _.some(serviceCategories, function(categoryId) { return categoryId == categoryModel.id; });
                        //DEBUG cross-filtering filter values
                        var validByProvider = true; //!_this._filterProviderId || _.isEmpty(serviceProviders) || _.some(serviceProviders, function(providerId) { return providerId == _this._filterProviderId; });
                        if (validByCategory && validByProvider) {
                            if (serviceModel.id == _this._filterServiceId) {
                                selectedServiceShown = true;
                            }
                            
                            return true;
                        } else {
                            return false;
                        }
                    }).map(function (serviceModel) { return serviceModel.toJSON(); });
                    
                    subitems.sort(function (s1, s2) {
                        if (s1.class_id && !s2.class_id) return -1;
                        if (!s1.class_id && s2.class_id) return 1;
                        
                        var s1inCategory = s1.position_in_category !== undefined ? ~~s1.position_in_category[categoryModel.id] : Infinity;
                        var s2inCategory = s2.position_in_category !== undefined ? ~~s2.position_in_category[categoryModel.id] : Infinity;
                        return s1inCategory - s2inCategory;
                    });
                    
                    if (!_.isEmpty(subitems)) {
                        subitems.unshift({
                            id: 'category_' + categoryModel.id,
                            name: Locale.getNonEscape('All services in %category%').replace('%category%', categoryModel.get('name'))
                        });
                        services.push({
                            group: true, 
                            name: categoryModel.get('name'), 
                            options: subitems
                        });
                    }
                });
            } else {
                this._serviceCollection.each(function (serviceModel) {
                    var serviceProviders = _.keys(serviceModel.get('unit_map'));
                    //DEBUG cross-filtering filter values
                    var validByProvider = true; //!_this._filterProviderId || _.isEmpty(serviceProviders) || _.some(serviceProviders, function(providerId) { return providerId == _this._filterProviderId; });
                    if (validByProvider) {
                        services.push(serviceModel.toJSON());
                        
                        if (serviceModel.id == this._filterServiceId) {
                            selectedServiceShown = true;
                        }
                    }
                });
                
                services.sort(function (s1, s2) {
                    // check for 'all services' etc
                    if (~s1.id) return 1;
                    if (~s2.id) return -1;
                    
                    // place classes first
                    if (s1.class_id && !s2.class_id) return -1;
                    if (!s1.class_id && s2.class_id) return 1;
                    
                    return ~~s1.position - ~~s2.position;
                });
            }
            //TODO why are we resetting filter just when there are no data filtered?
            // if (!selectedServiceShown) {
            //     this._filterServiceId = null;
            // }
            result.services = services;
            result.service_id = this._filterServiceId;
            result.services_disabled = services.length == _emptyServicesLength; 
            
            var selectedService = this._serviceCollection.get(this._filterServiceId);
            if (selectedService && !!selectedService.get('class_id')) {
                result.providers_disabled = true;
                result.providers = [];
            } 
            
            result.activeTimeOfDay = this._activeTimeOfDay;
            
            var weekdays = new Date().getWeekDaysList('short');
            var isMondayFirstDay = Config.getInstance().isMondayFirstDay();
            result.daysOfWeek = weekdays.map(function (dayName, index) {
                return {
                    id: isMondayFirstDay ? (index + 1) % 7 : index,
                    name: dayName
                };
            });
            result.selectedDaysOfWeek = this._selectedDaysOfWeek;
            
            var predefined = this.getOption('predefined') || {};
            if (predefined.service || predefined.category) {
                result.services_disabled = true;
            }
            if (predefined.provider || predefined.location) {
                result.providers_disabled = true;
            }
            return result;
        },
        
        _onClickMorning: function () {
            this.toggleActiveTimeOfDay('morning');
        },
        
        _onClickAfternoon: function () {
            this.toggleActiveTimeOfDay('afternoon');
        },
        
        _onClickEvening: function () {
            this.toggleActiveTimeOfDay('evening');
        },
        
        _onClickDayOfWeek: function (event) {
            var id = jQuery(event.target).data('id');
            
            if (_.contains(this._selectedDaysOfWeek, id)) {
                this._selectedDaysOfWeek = _.without(this._selectedDaysOfWeek, id);
            } else {
                this._selectedDaysOfWeek.push(id);
            }
            
            this.render();
        },
        
        toggleActiveTimeOfDay: function (timeOfDay) {
            if (this._activeTimeOfDay == timeOfDay) {
                this._activeTimeOfDay = null;
            } else {
                this._activeTimeOfDay = timeOfDay;
            }
            
            this.render();
        },
        
        _onChangeProviderFilter: function () {
            this._filterProviderId = this.ui.provider.val();
            this.triggerMethod('change:provider', this._filterProviderId);
        }, 
        
        _onChangeServiceFilter: function () {
            this._filterServiceId = this.ui.service.val();
            this.triggerMethod('change:service', this._filterServiceId);
        },
        
        _onTimeCollectionError: function (collection, xhr) {
            this._collectionError = xhr.responseJSON;
            this._timeCollection.reset();
            this._updateCollection();
            this.render();
        },
        
        _onTimeCollectionSync: function () {
            this._collectionError = null;
            this.render();
        }

    });

});
